import React from "react";
import { Link } from "react-router-dom";
import { getDateAgo } from "../../helper/Helper";
import { ArrowRight } from "lucide-react";

function Card({ item }) {
  return (
    <>
      <div className="blog-card-custom">
        <Link to={`/blog/${item?.slug}`} className="blog-img-wrapper">
          <img src={item?.image} alt={item?.title} loading="lazy" />
          {item?.date && <div className="blog-category-badge">{getDateAgo(item?.date)}</div>}
        </Link>
        <div className="blog-content-wrapper">
          <h4 className="blog-card-title">  {item?.title}</h4>
          <p className="blog-card-desc">   {item?.shortDescription}</p>

          <div className="blog-footer mt-4">
            <Link to={`/blog/${item?.slug}`}  className="read-more-btn">
              Read Story <ArrowRight size={16} className="ms-2" />
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}

export default Card;
